
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import PageRequest from "../../../store/entities/page-request";
// import EditCampana from "./edit-campana.vue";
import PeopleFind from "../../../components/People/people-find.vue";
import Campana from "../../../store/entities/OZONE/campana";
import { Moment } from "moment";
import moment from "moment";
import { get } from "js-cookie";
import { jsPDF } from "jspdf";
import JsBarcode from 'jsbarcode';
import { Canvg } from "canvg";

class PageFicheroEnvioRequest extends PageRequest {
  keyword: string;
  fechaInicio: Date;
  fechaFin: Date;
  campana: Campana;
  enviada: Boolean;
  emitida: Boolean;
  rechazada: Boolean;  
  pendiente: Boolean;
  ids: Array<number>;
}

@Component({
  components: {
    PeopleFind,
  },
})
export default class Exportaciones extends AbpBase {
  //filters
  pagerequest: PageFicheroEnvioRequest = new PageFicheroEnvioRequest();
  creationTime: Date[] = [];
  authorsHeaderBtns: String = "all";
  createModalShow: boolean = false;
  editModalShow: boolean = false;
  findModalShow: boolean = false;
  clienteNombre: string = "";
  fechaEmision: Moment = null;
  selectedEnvios: Array<number> = [];

  onChange = (e) => {
    var id = e.target.id;
    var value = e.target.checked;
    if (value) {
      this.selectedEnvios.push(id);
    } else {
      const index = this.selectedEnvios.indexOf(id);
      if (index > -1) {
        this.selectedEnvios.splice(index, 1);
      }
    }
  };

  campana: Campana = null;

  searchDefinition: {}[] = [
    {
      fieldName: "Busqueda",
      fieldType: "text",
      fieldBind: "keyword",
      value: "",
    },
    {
      fieldName: "Fecha Inicio",
      fieldType: "date",
      fieldBind: "fechaInicio",
      value: "",
    },
    {
      fieldName: "Fecha Fin",
      fieldType: "date",
      fieldBind: "fechaFin",
      value: "",
    },
    {
      fieldName: "Campaña",
      fieldType: "custom",
      custom: "select-campana",
      fieldBind: "campana",
      value: this.campana,
    },
    {
      fieldName: "Pendiente",
      fieldType: "checkbox",
      fieldBind: "pendiente",
      value: false,
    },
    // {
    //   fieldName: "Enviada",
    //   fieldType: "checkbox",
    //   fieldBind: "enviada",
    //   value: false,
    // },
    {
      fieldName: "Emitida",
      fieldType: "checkbox",
      fieldBind: "emitida",
      value: false,
    },
    // {
    //   fieldName: "Rechazada",
    //   fieldType: "checkbox",
    //   fieldBind: "rechazada",
    //   value: false,
    // },
  ];

  pagination: any = {};

  get list() {
      
    return this.$store.state.ficheroEnvio.list;
    
  }
  get loading() {
    return this.$store.state.ficheroEnvio.loading;
  }

  getSearch = async (model) => {
    model.forEach((element) => {
      if (element.value) {
        this.pagerequest[element.fieldBind] = element.value;
      } else {
        delete this.pagerequest[element.fieldBind];
      }
    });
    await this.getpage();
    this.findModalShow = false;
  };

  async hide() {
    this.findModalShow = false;
  }
  async find() {
    this.findModalShow = true;
  }

  pageChange(page: number) {
    this.$store.commit("ficheroEnvio/setCurrentPage", page);
    this.getpage();
  }

  pagesizeChange(pagesize: number) {
    this.$store.commit("ficheroEnvio/setPageSize", pagesize);
    this.getpage();
  }

  cancelarEmitido(e) {
    this.fechaEmision = null;
  }

  async emitido(sepa) {

    await this.$store
      .dispatch({
        type: "ficheroEnvio/marcarEmitido",
        data: {
          id: sepa.id,
          fechaExportacion: this.fechaEmision.format("YYYY/MM/DD"),
        },
      })
      .then(async () => {
        this.$message.success(
          "El fichero y sus envios han sido marcados como enviados."
        );
        await this.getpage();
      });
  }

  logTags(tags) {
  console.log('Valor de tags:', tags);
  return false; // Para que no renderice nada en el DOM
}

getPrefijo(fichero: string) {
  if (!fichero) return "";
  const idx = fichero.indexOf("_");
  return idx > -1 ? fichero.substring(0, idx) : fichero;
}

handleTagChange(value, tags) {
  let fileName = '';
  switch (value) {
    case '1':
      fileName = this.getPrefijo(tags.fichero) + '_Envialia_' + new Date(tags.fechaCreacion).toLocaleDateString('es-ES').replace(/\//g,'_');
      this.downloadShippingTag(1, fileName, tags.id, tags.envios);
      break;
    case '2':
      fileName = this.getPrefijo(tags.fichero) + '_GECO_' + new Date(tags.fechaCreacion).toLocaleDateString('es-ES').replace(/\//g,'_') + '.xlsx';
      this.downloadShippingTag(2, fileName, tags.id, tags.envios);
      break;
    case '3':
      fileName = this.getPrefijo(tags.fichero) + '_PDM_' + new Date(tags.fechaCreacion).toLocaleDateString('es-ES').replace(/\//g,'_') + '.pdf';
      this.downloadShippingTag(3, fileName, tags.id, tags.envios);
      break;
    case '4':
      fileName = this.getPrefijo(tags.fichero) + '_GLS_' + new Date(tags.fechaCreacion).toLocaleDateString('es-ES').replace(/\//g,'_') + '.xlsx';
      this.downloadShippingTag(4, fileName, tags.id, tags.envios);
      break;
  }
}

handleFileOption(value, files) {
  let fileName = '';
  let type = 2;
debugger;
  if (value === 'ficheroEnvio') {
    if (!files.fichero.startsWith('C') && !files.fichero.startsWith('P')) {
      fileName = 'Envio_' + new Date(files.fechaCreacion).toLocaleDateString('es-ES').replace(/\//g,'_') + '.csv';
      type = 2;
    } else {
      fileName = files.fichero;
      type = 2;
    }
  } else if (value === 'envioWP') {
    if (!files.fichero.startsWith('C') && !files.fichero.startsWith('P')) {
      fileName = 'Envios_' + new Date(files.fechaCreacion).toLocaleDateString('es-ES').replace(/\//g,'_') + '.csv';
      type = 2;
    } else {
      fileName = files.fichero.replace('Envios_', 'EnviosWP_');
      type = 3;
    }
  }

  if (fileName) {
    this.download(type, fileName, files.id);
  }
}

  async eliminar(sepa) {
    await this.$store
      .dispatch({
        type: "ficheroEnvio/eliminarFichero",
        data: {
          id: sepa.id,
        },
      })
      .then(async () => {
        this.$message.success(
          "Fichero eliminado y revertidos."
        );
        await this.getpage();
      });
  }

  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;


    await this.$store.dispatch({
      type: "ficheroEnvio/getAll",
      data: this.pagerequest,
    });

    const pagination = { ...this.pagination };
    pagination.total = this.$store.state.ficheroEnvio.totalCount;
    pagination.pageSize = this.$store.state.ficheroEnvio.pageSize;
    pagination.current = this.$store.state.ficheroEnvio.currentPage;
    this.pagination = pagination;
  }

  get pageSize() {
    return this.$store.state.ficheroEnvio.pageSize;
  }

  get totalCount() {
    return this.$store.state.ficheroEnvio.totalCount;
  }

  get currentPage() {
    return this.$store.state.ficheroEnvio.currentPage;
  }

  set currentPage(page) {
    this.$store.commit("ficheroEnvio/setCurrentPage", page);
    this.getpage();
  }

  handleTableChange = async (pagination, filters, sorter) => {
    this.$store.commit("ficheroEnvio/setCurrentPage", pagination.current);
    this.getpage();

    await this.getpage();
  };

  editRow(item, index, button) {
    //this.edit()
    
    this.$router.push({ name: "envioslist", query: { exp: item.id } });
  }

  async download(type, fileName, id) {
    debugger;
    this.pagerequest.ids = this.selectedEnvios;
    await this.$store.dispatch({
      type: type == 1 ? "ficheroEnvio/downloadSEPA" : "ficheroEnvio/downloadReport",
      data: { id:  id,
        fichero: fileName,
        tipo: type },
    }).then((data) => {
        
        let blob = this.dataURLtoFile("data:text/" +  (type == 1 ? "xml" : "csv") + ";base64," + data, fileName);
        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
    });
  }

  async downloadShippingTag(shippingService, fileName, id, totalShipments){

    var MIMEType = "data:text/xlsx;base64,";
    var ruta = "ficheroEnvio/dowloadEnvialiaTag";
    if(shippingService === 1){
      if(totalShipments > 1000){
        MIMEType = "data:application/zip;base64,";
        fileName += ".zip"
      }
      else{
        fileName += ".xlsx"
      }
    }
    
    if (shippingService === 2) {ruta = "ficheroEnvio/dowloadGECOTag";}
    if(shippingService === 3) {ruta = "ficheroEnvio/dowloadEtiquetasTag";}
    if (shippingService === 4) {ruta = "ficheroEnvio/dowloadGLSTag";}

    this.pagerequest.ids = this.selectedEnvios;
    await this.$store.dispatch({
      //type: shippingService == 1 ? "ficheroEnvio/dowloadEnvialiaTag" : "ficheroEnvio/dowloadGECOTag",
      type: ruta,
      data: { id:  id },
    }).then((data) => {
        let blob = this.dataURLtoFile(MIMEType + data, fileName);
        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
    });
  }

  dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  stateColorScheme(state: number) {
    switch (state) {
      case 1:
        return "ant-tag-primary";
      case 3:
        return "ant-tag-secondary";
      case 4:
        return "ant-tag-success";
      case 5:
        return "ant-tag-danger";
    }
  }

  columns = [
    {
      title: this.L("Nombre Fichero"),
      scopedSlots: { customRender: "func" },
    },
    {
      title: this.L("Fichero"),
      scopedSlots: { customRender: "files" },
    },
    {
      title: this.L("Etiqueta"),
      scopedSlots: { customRender: "tags"},
    },
    {
      title: this.L("Pendiente"),
      dataIndex: "pendiente",
      scopedSlots: { customRender: "pending" },
    },
    {
      title: this.L("Envios"),
      scopedSlots: { customRender: "trans" },
    },
    {
      title: this.L("Fecha Creacion"),
      dataIndex: "fechaCreacion",
      scopedSlots: { customRender: "date" },
    },
    {
      title: this.L("Fecha Envio"),
      dataIndex: "fechaExportacion",
      scopedSlots: { customRender: "date" },
    },
    {
      scopedSlots: { customRender: "editBtn" },
      width: 10,
      title: "",
    },
    {
      scopedSlots: { customRender: "checkBtn" },
      width: 10,
      title: "",
    },
    {
      scopedSlots: { customRender: "deleteBtn" },
      width: 10,
      title: "",
    },
  ];

  async created() {

    this.getpage();
  }


}
